export function applyPostTeamSwitchNavigation(): void {
  if (
    /^\/v2\/dataset_groups\/\d+\/audiences\/\d+(?:\/edit)?\/?$/.test(
      window.location.pathname
    )
  ) {
    window.location.assign('/audiences');
  } else {
    window.location.reload();
  }
}
